import { FormSection } from '../../components/ui/FormSection';

interface FoodInformationSectionProps {
  foodAvailableForPurchase: boolean;
  onFoodAvailableForPurchaseChange: (value: boolean) => void;
  foodDescription: string;
  onFoodDescriptionChange: (value: string) => void;
}

export const FoodInformationSection = ({
  foodAvailableForPurchase,
  onFoodAvailableForPurchaseChange,
  foodDescription,
  onFoodDescriptionChange,
}: FoodInformationSectionProps) => (
  <FormSection title="Food Information">
    <div className="flex items-center">
      <input
        type="checkbox"
        id="foodAvailableForPurchase"
        checked={foodAvailableForPurchase}
        onChange={(e) => onFoodAvailableForPurchaseChange(e.target.checked)}
        className="mr-3 h-4 w-4 text-primary-600 focus:ring-info-500 border-gray-300 rounded"
      />
      <label htmlFor="foodAvailableForPurchase" className="text-sm font-medium text-gray-700">
        Food available for purchase
      </label>
    </div>

    <div>
      <label htmlFor="foodDescription" className="block text-sm font-medium text-gray-700 mb-1">
        Food Description
      </label>
      <textarea
        id="foodDescription"
        value={foodDescription}
        onChange={(e) => onFoodDescriptionChange(e.target.value)}
        rows={3}
        placeholder="Describe the food offerings, menu highlights, or dining options available..."
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-info-500"
      />
    </div>
  </FormSection>
);
